module.exports = __webpack_public_path__ + "img/successBg.3d3871a0.png";